import { useEffect, Dispatch } from 'react';
import { IAction, ActionTypeValues, namespace } from '@/context';
import Cookies from 'js-cookie';

const useSensors = ({
  dispatch,
}: { dispatch: Dispatch<IAction<any> | Array<IAction<any>>> }) => {

  const initSensors = async () => {
    const {
      initSensors: init, login, logout, track, TRACK_EVENTS, extractThreadTags, getChannelNameBySlug,
    } = (await import('../utils/sensors'));

    init();
    const userCenterId = Cookies.get('_uc_id');
    if (userCenterId) {
      login(userCenterId);
    } else {
      logout();
    }

    dispatch({
      type: ActionTypeValues.UPDATE_APP_SENSORS,
      payload: {
        track, TRACK_EVENTS, extractThreadTags, getChannelNameBySlug,
      },
      namespace: namespace.app,
    });
  }

  useEffect(() => {
    initSensors();
  }, []);
};

export default useSensors;
